module.exports = __webpack_public_path__ + "img/icon.46a6054e.jpg";